import { defineMessages } from '@jutro/locale';

export default defineMessages({
    transactionDateColumn: {
        id: 'ml.gateway.views.ActivityReports.MLPaymentLogComponent.TRANSACTION DATE',
        defaultMessage: 'TRANSACTION DATE'
    },
    customerNameColumn: {
        id: 'ml.gateway.views.ActivityReports.MLPaymentLogComponent.CUSTOMER NAME',
        defaultMessage: 'CUSTOMER NAME'
    },
    productColumn: {
        id: 'ml.gateway.views.ActivityReports.MLPaymentLogComponent.PRODUCT',
        defaultMessage: 'PRODUCT'
    },
    policyColumn: {
        id: 'ml.gateway.views.ActivityReports.MLPaymentLogComponent.POLICY #',
        defaultMessage: 'POLICY #'
    },
    paymentMethodColumn: {
        id: 'ml.gateway.views.ActivityReports.MLPaymentLogComponent.PAYMENT METHOD',
        defaultMessage: 'PAYMENT METHOD'
    },
    amountColumn: {
        id: 'ml.gateway.views.ActivityReports.MLPaymnetLogComponent.AMOUNT',
        defaultMessage: 'AMOUNT'
    },
    paymentTypeColumn: {
        id: 'ml.gateway.views.ActivityReports.MLPaymnetLogComponent.PAYMENT TYPE',
        defaultMessage: 'PAYMENT TYPE'
    },
    last4DigitsColumn: {
        id: 'ml.gateway.views.ActivityReports.MLPaymnetLogComponent.LAST 4 DIGITS',
        defaultMessage: 'LAST 4 DIGITS'
    },
    noPaymentsFound: {
        id: 'ml.gateway.views.ActivityReports.MLContingenciesReport.No recent payments found',
        defaultMessage: 'No recent payments found'
    },
    loading: {
        id: 'ml.gateway.views.ActivityReports.MLPaymentLogComponent.Loading...',
        defaultMessage: 'Loading...'
    },
    viewAllPayments: {
        id: 'ml.gateway.views.ActivityReports.MLPaymentLogComponent.VIEW ALL PAYMENTS',
        defaultMessage: 'VIEW ALL PAYMENTS'
    },
    paymentDateRangs: {
        id: 'ml.gateway.views.ActivityReports.MLPaymentLogComponent.Payment Date Range',
        defaultMessage: 'Payment Date Range'
    },
    bankAccount: {
        id: 'ml.gateway.views.ActivityReports.MLPaymentLogComponent.Bank Account',
        defaultMessage: 'Bank Account'
    },
    creditDebitCard: {
        id: 'ml.gateway.views.ActivityReports.mlPaymentLogComponent.Credit Debit Card',
        defaultMessage: 'Credit/Debit Card'
    },
    agencySweep: {
        id: 'ml.gateway.views.ActivityReports.mlPaymentLogComponent.Agency Sweep',
        defaultMessage: 'Agency Sweep'
    },
    recentPayments: {
        id: 'ml.gateway.views.ActivityReports.mlPaymentLogComponent.Recent Payments',
        defaultMessage: 'Recent Payments'
    }
});
